<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      overflow: hidden;
      text-overflow: ellipsis;
      color: colors.get(black_90);
      @include mixins.body4();
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  // Components
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get store from context
  const { activePopUpModalStore } = getContext(CONTACT_CTAS_CONTEXT);

  $: actions = [
    { kind: "generalNote", label: "Note", icon: "far fa-note" },
    { kind: "phoneCallNote", label: "Call", icon: "far fa-phone" },
    { kind: "smsNote", label: "SMS", icon: "far fa-sms" },
    { kind: "meetingNote", label: "Meeting", icon: "far fa-calendar" },
    {
      kind: "interviewNote",
      label: "Interview",
      icon: "far fa-clipboard-question",
      hidden: !$userStore.hasCrm,
    },
  ];

  let closeDropdown;
  const openModal = (kind, label) => {
    if (closeDropdown) closeDropdown();
    activePopUpModalStore.set({ modal: "logActivity", kind, label });
  };
</script>

<div class="cta-wrapper">
  <Dropdown
    kind="secondary"
    size="candidate-cta"
    placement="bottom"
    tooltipPlacement="top"
    dynamicWidth={false}
    leadingIcon=""
    trailingIcon=""
    bind:close={closeDropdown}
  >
    <IconScale slot="button" class="fa-regular fa-pen" size="medium" />
    <span slot="tooltip">Add different types of notes to this contact</span>
    {#each actions as action}
      {@const { kind, label, icon, hidden } = action}
      {#if !hidden}
        <ListItem {icon} onclick={() => openModal(kind, label)}>
          {label}
        </ListItem>
      {/if}
    {/each}
  </Dropdown>
  <span class="cta-label">Log note</span>
</div>
